import settings from '@/settings'

const filtrar = (headers, filtros) => {
  let url = `${settings.apetrusApi}/funcionarios/filtro/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  filtrar
}
